export const FILTERS_ARGS = {
  SEARCH: 'search',
  ACTIVE_PLAN: 'active_plan',
  IS_ACTIVE: 'is_active',
};


export const SORT_ARGS = {
  ORDERING: 'ordering',
};
